import ReactDOM from 'react-dom';
import App from './App';
import { LifeCycles, registerApplication, start } from "single-spa";

ReactDOM.render(<App />,document.getElementById('root'));

registerApplication({
  name: "activation-manager-webui",
  app: (): Promise<LifeCycles> => (window as any).System.import("@simplex/activation-manager-webui"),
  activeWhen: ["/service-activation","/activation"]
});

registerApplication({
  name: "clients-manager-webui",
  app: (): Promise<LifeCycles> => (window as any).System.import("@simplex/clients-manager-webui"),
  activeWhen: "/contact"
});

registerApplication({
  name: "devices-manager-webui",
  app: (): Promise<LifeCycles> => (window as any).System.import("@simplex/devices-manager-webui"),
  activeWhen: "/device"
});

registerApplication({
  name: "user-authentication-ui",
  app: (): Promise<LifeCycles> => (window as any).System.import("@simplex/user-authentication-ui"),
  activeWhen: (location) => location.pathname.toLowerCase() === "/login"
});

registerApplication({
  name: "customer-manager-webui",
  app: (): Promise<LifeCycles> => (window as any).System.import("@simplex/customer-manager-webui"),
  activeWhen: "/suspend"
});

registerApplication({
  name: "alarm-notification-reporter-webui",
  app: (): Promise<LifeCycles> => (window as any).System.import("@simplex/alarm-notification-reporter-webui"),
  activeWhen: ["/alarm-report-wts", "/alarm-report-wts-trace", "/alarm-report-per-day"]
});


registerApplication({
  name: "yielde-manager-webui",
  app: (): Promise<LifeCycles> => (window as any).System.import("@simplex/yielde-manager-webui"),
  activeWhen: "/yielde"
});

registerApplication({
  name: "yielde-reporter-webui",
  app: (): Promise<LifeCycles> => (window as any).System.import("@simplex/yielde-reporter-webui"),
  activeWhen: "/reporter-yieldes"
});

registerApplication({
  name: "notifier",
  app: (): Promise<LifeCycles> => (window as any).System.import("@simplex/notifier"),
  activeWhen: "/"
});

registerApplication({
  name: "platform-user-searcher-webui",
  app: (): Promise<LifeCycles> => (window as any).System.import("@simplex/platform-user-searcher-webui"),
  activeWhen: "/users"
});

registerApplication({
  name: "monitoring-custom-follow-register-webui",
  app: (): Promise<LifeCycles> => (window as any).System.import("@simplex/monitoring-custom-follow-register-webui"),
  activeWhen: "/custom-follow-register"
});

registerApplication({
  name: "monitoring-custom-follow-reporter-webui",
  app: (): Promise<LifeCycles> => (window as any).System.import("@simplex/monitoring-custom-follow-reporter-webui"),
  activeWhen: "/custom-follow-reporter"
});

registerApplication({
  name: "fuel-dipstick-report-webui",
  app: (): Promise<LifeCycles> => (window as any).System.import("@simplex/fuel-dipstick-report-webui"),
  activeWhen: "/fuel-report"
});

registerApplication({
  name: "monitoring-custom-follow-attender-webui",
  app: (): Promise<LifeCycles> => (window as any).System.import("@simplex/monitoring-custom-follow-attender-webui"),
  activeWhen: "/custom-follow-attender"
});

registerApplication({
  name: "simplex-platform-menu-webui",
  app: (): Promise<LifeCycles> => (window as any).System.import("@simplex/simplex-platform-menu-webui"),
  activeWhen: "/menu-management"
});

registerApplication({
  name: "devices-massive-creator-webui",
  app: (): Promise<LifeCycles> => (window as any).System.import("@simplex/devices-massive-creator-webui"),
  activeWhen: "/units-massive-load"
});

registerApplication({
  name: "businessname-autosuspension-excluded-webui",
  app: (): Promise<LifeCycles> => (window as any).System.import("@simplex/businessname-autosuspension-excluded-webui"),
  activeWhen: "/businessname-autosuspension-excluded"
});

registerApplication({
  name: "vehicle-preactivatedeleter-webui",
  app: (): Promise<LifeCycles> => (window as any).System.import("@simplex/vehicle-preactivatedeleter-webui"),
  activeWhen: "/vehicle-preactivate-deleter"
});

registerApplication({
  name: "businessname-suspendreporter-webui",
  app: (): Promise<LifeCycles> => (window as any).System.import("@simplex/businessname-suspendreporter-webui"),
  activeWhen: "/daily-supension-report"
});

registerApplication({
  name: "alarm-customer-configuration-manager-webui",
  app: (): Promise<LifeCycles> => (window as any).System.import("@simplex/alarm-customer-configuration-manager-webui"),
  activeWhen: "/alarm-customer-configuration"
});

registerApplication({
  name: "massives-deactivate-schedule-webui",
  app: (): Promise<LifeCycles> => (window as any).System.import("@simplex/massives-deactivate-schedule-webui"),
  activeWhen: "/massives-deactivate-schedule"
});

registerApplication({
  name: "load-retention-manager-webui",
  app: (): Promise<LifeCycles> => (window as any).System.import("@simplex/load-retention-manager-webui"),
  activeWhen: "/load-retention-clients"
});

registerApplication({
  name: "vehicle-deactivateschedulemanager-webui",
  app: (): Promise<LifeCycles> => (window as any).System.import("@simplex/vehicle-deactivateschedulemanager-webui"),
  activeWhen: "/deactivation-schedule-manager"
});

registerApplication({
  name: "devices-serial-migration-manager-webui",
  app: (): Promise<LifeCycles> => (window as any).System.import("@simplex/devices-serial-migration-manager-webui"),
  activeWhen: ["/serial-assignment","/serial-assignment-load", "/serial-assignment-history"]
});

registerApplication({
  name: "vehicle-schedule-status-change-webui",
  app: (): Promise<LifeCycles> => (window as any).System.import("@simplex/vehicle-schedule-status-change-webui"),
  activeWhen: ["/vehicle-schedule-status-change", "/vehicle-schedule-status-change-create"]
});

registerApplication({
  name: "load-plates-scheduled-deactivation-webui",
  app: (): Promise<LifeCycles> => (window as any).System.import("@simplex/load-plates-scheduled-deactivation-webui"),
  activeWhen: "/load-plates-scheduled-deactivation"
});

registerApplication({
  name: "businessname-down-payment-ui",
  app: (): Promise<LifeCycles> => (window as any).System.import("@simplex/businessname-down-payment-ui"),
  activeWhen: "/businessname-down-payment"
});

registerApplication({
  name: "accounting-dian-efacture-webui",
  app: (): Promise<LifeCycles> => (window as any).System.import("@simplex/accounting-dian-efacture-webui"),
  activeWhen: "/dian-efacture-search-documents"
});

registerApplication({
  name: "ado-plan-pricechange-webui",
  app: (): Promise<LifeCycles> => (window as any).System.import("@simplex/ado-plan-pricechange-webui"),
  activeWhen: "/price-change"
});

registerApplication({
  name: "accounting-dian-create-credit-note-webui",
  app: (): Promise<LifeCycles> => (window as any).System.import("@simplex/accounting-dian-create-credit-note-webui"),
  activeWhen: "/dian-create-credit-note"
});
registerApplication({
  name: "vehicle-techninicalinfo-webui",
  app: (): Promise<LifeCycles> => (window as any).System.import("@simplex/vehicle-techninicalinfo-webui"),
  activeWhen: "/vehicle-technical-info"
});

registerApplication({
  name: "devices-alteredfrequencyreport-webui",
  app: (): Promise<LifeCycles> => (window as any).System.import("@simplex/devices-alteredfrequencyreport-webui"),
  activeWhen: "/altered-frequency-report"
});
registerApplication({
  name: "businessname-checknameintegrator-webui",
  app: (): Promise<LifeCycles> => (window as any).System.import("@simplex/businessname-checknameintegrator-webui"),
  activeWhen: "/businessname-checknameintegrator"
});

registerApplication({
  name: "consumption-report-ui",
  app: (): Promise<LifeCycles> => (window as any).System.import("@simplex/consumption-report-ui"),
  activeWhen: "/consumption-report"
});

start();